import { Box, Container, Typography, Divider } from "@mui/material";

const Support = () => {
  return (
    <Container
      maxWidth="md"
      sx={{ py: 4 }}
    >
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h3"
          component="h1"
          sx={{ mb: 2, fontWeight: "bold" }}
        >
          SaSSe Mobile Support
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Last Updated: February 21, 2026
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "bold" }}
        >
          How to Get Support
        </Typography>
        <Typography paragraph>
          SaSSe Mobile is an internal business application for authorized field
          representatives. For support, field representatives must contact their
          direct supervisor.
        </Typography>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "bold" }}
        >
          Support Process
        </Typography>
        <Box
          component="ul"
          sx={{ pl: 3, mb: 2 }}
        >
          <Typography
            component="li"
            paragraph
          >
            Contact your direct supervisor for first-line assistance.
          </Typography>
          <Typography
            component="li"
            paragraph
          >
            Supervisors handle troubleshooting, account access requests, and
            issue escalation.
          </Typography>
          <Typography
            component="li"
            paragraph
          >
            If additional technical review is required, supervisors escalate
            through internal operations and IT channels.
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Box sx={{ mb: 2 }}>
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "bold" }}
        >
          Access Notice
        </Typography>
        <Typography paragraph>
          This application is intended for authorized company personnel only.
        </Typography>
      </Box>
    </Container>
  );
};

export default Support;
